export default __webpack_public_path__ + "static/media/house-15.dea6478b.jpg";